import { toCents } from "@alm/domain";

const DAY_MS = 86_400_000;

/** A credit the way a ledger prints one: "-$12.00" reads "($12.00)". Display only. */
export function accounting(amount: string | null | undefined): string {
  if (!amount) return "-";
  return amount.startsWith("-") ? `(${amount.slice(1)})` : amount;
}

/** Whether a money string is more than zero; a malformed one counts as nothing owed. */
export function owes(amount: string | null | undefined): boolean {
  if (!amount) return false;
  // Whether a screen shows a balance as owing; payments post the server's own figure.
  try {
    return toCents(amount) > 0;
  } catch {
    return false;
  }
}

/** Whole days since a due date, 0 while it has not passed. */
export function daysPastDue(due: string | Date | null | undefined, now = Date.now()): number {
  if (!due) return 0;
  const time = typeof due === "string" ? Date.parse(due) : due.getTime();
  if (Number.isNaN(time)) return 0;
  return Math.max(0, Math.floor((now - time) / DAY_MS));
}
